import apiClient from "@/utils/apiClient";

const companyService = {
  // 🏢 Get company profile
  getProfile: () => apiClient.get("/company-profile"),

  // ✏️ Update company profile
  updateProfile: (data) => apiClient.put("/company-profile", data),

  // 🖼 Upload assets (logo, banner, etc.)
  uploadAsset: (type, formData) =>
    apiClient.post(`/company-profile/upload-${type}`, formData),

  // 🌍 Get company destinations
  getDestinations: () => apiClient.get("/company-profile/destinations"),
};

export default companyService;
